export default __webpack_public_path__ + "static/media/group1.1c8de7fa.png";